<div class="card">
    <div class="card-body"  style="flex-grow: 4;">
        <div class="container">
            <form [formGroup]="addMaterialForm" class="ng-pristine ng-valid">
              <!-- Client and Job Selection -->
              <!-- <div class="row">
                <div class="col form-group mb-3">
                  <label class="form-label">Client Name</label>
                  <select class="form-select" formControlName="clientName" (change)="updateJobList($event.target.value)">
                    <option value="" disabled>Select Client</option>
                    <option *ngFor="let client of clientList" [value]="client.clientName">{{ client.clientName }}</option>
                  </select>
                </div>
                <div class="col form-group mb-3">
                  <label class="form-label">Job Name</label>
                  <select class="form-select" formControlName="jobName" (change)="onSelectJob($event.target.value)">
                    <option value="" disabled>Select Job Name</option>
                    <option *ngFor="let job of jobList" [value]="job.jobName">{{ job.jobName }}</option>
                  </select>
                </div>
              </div> -->
              <ng-container *ngIf="orderId">
                <!-- Render this section if orderId is present -->
                <div class="row">
                  <div class="col form-group mb-3">
                    <label class="form-label">Client Name</label>
                    <input type="text" class="form-control" formControlName="clientName" disabled>
                  </div>
                  <div class="col form-group mb-3">
                    <label class="form-label">Job Name</label>
                    <input type="text" class="form-control" formControlName="jobName" disabled>
                  </div>
                 
                </div>
              </ng-container>
            
              <ng-container *ngIf="!orderId">
                <!-- Render this section if orderId is not present -->
                <div class="row">
                  <div class="col form-group mb-3">
                    <label class="form-label">Client Name</label>
                    <select class="form-select" formControlName="clientName" (change)="updateJobList($event.target.value)">
                      <option value="" disabled>Select Client</option>
                      <option *ngFor="let client of clientList" [value]="client.clientName">{{ client.clientName }}</option>
                    </select>
                  </div>
                  <div class="col form-group mb-3">
                    <label class="form-label">Job Name</label>
                    <select class="form-select" formControlName="jobName" (change)="onSelectJob($event.target.value)">
                      <option value="" disabled>Select Job Name</option>
                      <option *ngFor="let job of jobList" [value]="job.jobName">{{ job.jobName }}</option>
                    </select>
                  </div>
                 
                </div>
              </ng-container>
            

              <!-- Order Details -->
              <div class="row">
                <div class="col form-group mb-3">
                  <label class="form-label">PO Number</label>
                  <input type="text" class="form-control" formControlName="poNum" placeholder="Po Number" readonly>
                </div>
                <div class="col form-group mb-3">
                  <label class="form-label">Order Qty</label>
                  <input type="text" class="form-control" formControlName="orderQty"  placeholder="Order Qty"readonly>
                </div>
                <div class="col form-group mb-3">
                  <label class="form-label">Average Wastage % </label>
                  <input type="text" class="form-control" formControlName="orderper" placeholder="Avg Waste">
                </div>
              </div>
         
             
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Process</th>
                      <th>Material</th>
                      <th>Density</th>
                      <th>Avg Wastage %</th>
                      <th>Thickness</th>
                      <th>GSM</th>
                      <th>Net RM</th>
                      <th>Wastage %</th>
                      <th>Mat_Required</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Loop through existing materials -->
                    <tr *ngFor="let material of Materials; let i = index">
                      <td>{{ material.process }}</td>
                      <td>{{ material.material }}</td>
                      <td>{{ material.density }}</td>
                      <td>{{ updateOperperValue() | number:'1.2-2' }}</td>
                      <td>{{ material.thickness }}</td>
                      <td>{{ material.gsm }}</td>
                      <td>{{ material.netRm }}</td>
                      <td>
                        <input type="text" formControlName="waste" [(ngModel)]="material.waste" placeholder="Enter Waste">
                      </td>
                      <td>{{ material.matRequired }}</td>
                      <td>
                        <button type="button" class="btn btn-outline-success btn-sm" (click)="calcMatReq(material)">
                          <i class="feather icon-dollar-sign"></i> Calc
                        </button>
                        <button type="button" class="btn btn-outline-danger btn-sm" (click)="deleteMaterial(i)">
                          <i class="feather icon-trash-2 text-danger"></i>
                        </button>
                      </td>
                    </tr>
                 
                  
                    
                   
                   
                    
                    
                   
                    
                  </tbody>
                </table>
              </div>
              
              <!-- Total Calculations -->
              <div class="row">
                <div class="col-8"></div>
                <div class="col-4">
                  <table class="table table-sm text-right">
                    <tbody class=" pt-2">
                      <tr>
                        <td><strong>Material Grand Total</strong></td>
                        <td class="text-right" id="material-grand-total">{{ grandTotalMatReq.toFixed(2) }} <span class="currency">Kgs</span></td>
                      </tr>
                      <tr>
                        <td>Wastage in kgs</td>
                        <td class="text-right" id="total-ht">{{wasteInKg.toFixed(2)}} <span class="currency">Kgs</span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-auto mt-4">
                <button type="submit" [disabled]="disableSaveBtn()" class="btn btn-outline-danger" (click)="saveAndContinue()">Save</button>
              </div>
            </form>
          </div>
          
          
          
</div>

  


  </div>